import { isoToLocalDate } from "@jugl-web/utils";
import {
  CreateSubtaskDto,
  CreatedSubtaskDto,
  LiveUpdateSubtaskDto,
  SubtaskDto,
  UpdateSubtaskDto,
  UpdatedSubtaskDto,
} from "./SubtaskDto";
import {
  CreateSubtaskModel,
  LiveUpdateSubtaskModel,
  SubtaskModel,
  UpdateSubtaskModel,
} from "./SubtaskModel";

// SubtaskDto -> SubtaskModel
export const transformSubtaskDtoToModel = (dto: SubtaskDto): SubtaskModel => ({
  attachmentsCount: dto.attachment_cnt || 0,
  commentsCount: dto.cmnt_cnt || 0,
  commentsUnread: dto.cmnt_unread || false,
  customFields: dto.custom_fields || {},
  completedAt: dto.completed_at ? isoToLocalDate(dto.completed_at) : null,
  createdBy: dto.created_by,
  dueAt: dto.due_at ? isoToLocalDate(dto.due_at) : null,
  id: dto.id,
  insertedAt: isoToLocalDate(dto.inserted_at),
  isCompleted: dto.is_completed,
  name: dto.name,
  order: dto.order,
  userId: dto.user_id,
});

// LiveUpdateSubtaskDto -> LiveUpdateSubtaskModel
export const transformLiveUpdateSubtaskDtoToModel = (
  dto: LiveUpdateSubtaskDto
): LiveUpdateSubtaskModel => ({
  id: dto.id,
  isCompleted: dto.is_completed,
  dueAt: dto.due_at ? isoToLocalDate(dto.due_at) : null,
  userId: dto.user_id,
  customFields: dto.custom_fields || {},
  name: dto.name,
  order: dto.order,
  createdBy: dto.created_by,
  completedAt: dto.completed_at ? isoToLocalDate(dto.completed_at) : null,
  insertedAt: isoToLocalDate(dto.inserted_at),
});

// CreatedSubtaskDto -> SubtaskModel
export const transformCreatedSubtaskDtoToSubtaskModel = (
  dto: CreatedSubtaskDto
): SubtaskModel =>
  transformSubtaskDtoToModel({
    ...dto,
    attachment_cnt: 0,
    cmnt_cnt: 0,
    cmnt_unread: false,
  });

// UpdatedSubtaskDto -> SubtaskModel
export const transformUpdatedSubtaskDtoToSubtaskModel = (
  dto: UpdatedSubtaskDto,
  updatedModel: SubtaskModel
): SubtaskModel =>
  transformSubtaskDtoToModel({
    ...dto,
    attachment_cnt: updatedModel.attachmentsCount,
    cmnt_cnt: updatedModel.commentsCount,
    cmnt_unread: updatedModel.commentsUnread,
  });

// SubtaskModel ->  UpdateSubtaskDto
export const transformSubtaskModelToUpdateSubtaskDto = (
  model: SubtaskModel
): UpdateSubtaskDto => ({
  name: model.name,
  due_at: model.dueAt?.toISOString() || null,
  user_id: model.userId,
  is_completed: model.isCompleted,
});

// CreateSubtaskModel -> CreateSubtaskDto
export const transformCreateSubtaskModelToDto = (
  model: CreateSubtaskModel
): CreateSubtaskDto => ({
  name: model.name,
  due_at: model.dueAt?.toISOString() || null,
  user_id: model.userId,
  is_completed: model.isCompleted,
});

// UpdateSubtaskModel -> UpdateSubtaskDto
export const transformUpdateSubtaskModelToDto = (
  model: UpdateSubtaskModel
): UpdateSubtaskDto => transformCreateSubtaskModelToDto(model);
